import { createSelector } from 'reselect';
import { keyBy } from 'lodash';
import isEmpty from 'lodash/isEmpty';
import { getOptionsOfCrewingStatuses } from '../../utils/selectors';
import { getAssignedVesselsData } from '../timeplans/selector';

const getRanks = (s) => s.ranks.data;

const getOptionsOfRoles = createSelector(
  [getRanks],
  (ranks) => ranks.map(({ id: value, attributes: { title: label } }) => ({ value, label })),
);

const getEngineTypes = (state) => state.engineTypes.data;
const getEngineTypeInputDebouncedValue = (state) => state.users.state.engineTypeInputDebouncedValue;

const getOptionsOfEngineTypes = createSelector( // that code is for perfomance because types.length > 1000
  [getEngineTypes, getEngineTypeInputDebouncedValue],
  (types, engineTypeInputDebouncedValue) => (!isEmpty(engineTypeInputDebouncedValue)
    ? types.filter(({ label }) => label.toLowerCase().includes(engineTypeInputDebouncedValue.toLowerCase()))
    : []),
);

const getTimeplanFormValues = (state) => state.form?.timeplans?.values || {};
const getAssignedVessels = getAssignedVesselsData;

const getManningScaleById = createSelector(
  [getAssignedVessels],
  ({ manningScales = [] }) => keyBy(manningScales, 'originId'),
);

export const getTargetOwnerId = createSelector(
  [getTimeplanFormValues, getAssignedVessels, getManningScaleById],
  (formValues, { assignedVesselsByVesselId = {} }, manningScaleById) => {
    if (!formValues) return null;

    // The timeplan form holds the target slot under different keys
    // depending on the flow:
    //   - editing an existing slot     → { msId }   (a manning-scale id)
    //   - adding a seafarer to a slot  → { vesselId, manningScaleId }
    //     (location.state from the card drop — has NO `msId`)
    // The original code only read `msId`, so the add-a-seafarer flow
    // (exactly when "Choose user for the timeplan" is used) always got
    // `targetOwnerId = null` → every candidate was wrongly flagged
    // "Assigned to a diff. owner pool". Resolve the vessel from any of
    // the shapes.
    const msKey = formValues.msId ?? formValues.manningScaleId;
    const vesselId = formValues.vesselId
      ?? (msKey != null ? manningScaleById[msKey]?.vessel_id : undefined);

    if (!vesselId) return null;

    return assignedVesselsByVesselId[vesselId]?.owner_id ?? null;
  },
);

export default (state) => ({
  ...state.usersSection,
  isOpen: state.timeplans.state.isUserSectionOpen,
  optionsOfEngineTypes: getOptionsOfEngineTypes(state),
  optionsOfEngineManufacturers: state.engineManufacturers.data,
  optionsOfCrewingStatuses: getOptionsOfCrewingStatuses(state),
  optionsOfRoles: getOptionsOfRoles(state),
  targetOwnerId: getTargetOwnerId(state),
});
